import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from './util';
const Medium = (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 20 20" }, { children: _jsx("g", { children: _jsx("path", { fill: "currentColor", d: "M16.805 1.638c-2.466-1.102-5.314.478-6.729 2.686C8.784 2.043 5.99.307 3.466 1.273a5.39 5.39 0 0 0-3.109 6.96c1.064 2.782 9.338 11.089 9.338 11.089s8.622-7.844 9.835-10.564a5.39 5.39 0 0 0-2.725-7.12z" }, void 0) }, void 0) }), void 0));
export const variants = {
    medium: Medium,
    default: Medium,
};
export default withVariants(variants);
